import { useState, useEffect } from 'react';
import { throttleToAnimationFrame, findNearestScroller } from '@utils/common';

function useIsSticky(ref, extraDeps) {
  const [isSticky, setSticky] = useState(false);
  useEffect(() => {
    const drawer = ref.current;
    const container = drawer?.parentElement;
    if (!drawer || !container) {
      return;
    }
    const onScroll = throttleToAnimationFrame(() => {
      const hasAppliedSticky = container.clientHeight - (drawer.clientHeight + drawer.offsetTop) > 50;
      setSticky(hasAppliedSticky);
    });
    onScroll();
    const scroller = findNearestScroller(drawer, "vertical") ?? window;
    scroller.addEventListener("scroll", onScroll);
    return () => {
      scroller.removeEventListener("scroll", onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...(extraDeps ?? [])]);
  return isSticky;
}

export { useIsSticky };
//# sourceMappingURL=hook.is-sticky.js.map
